import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Avatar, FloatButton } from "antd";
import { List, Toast } from "antd-mobile";
import axios from "axios";
import $ from "jquery";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactFileReader from "react-file-reader";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { getFileLiveUrl, jsonToQuery, momentDate, siteUrl } from "../../utils";
import { SELECT_USER_PHOTO } from "../../utils/data";
import { ServiceUrl } from "../../utils/serviceUrl";
import { MOB_ICONS, customSorting, groupByMultiple } from "../../utils";
import Header from "../header";
// import ContentEditor from "../../website/contentEditor";

const Events = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showAdd1, setShowAdd1] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showEdit, setEditView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [totalBalance, setTotalBalance] = useState(0);
  const [showFeeModal, setShowFeeModal] = useState(false);
  const [viewData, setViewData] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [oldFile, setOldFile] = useState("");
  const [selectedFiletwo, setSelectedFiletwo] = useState("");
  const [oldFiletwo, setOldFiletwo] = useState("");
  const [selectedFilethree, setSelectedFilethree] = useState("");
  const [selectedFiletfour, setSelectedFilefour] = useState("");
  const [club, setClub] = useState([]);
  const [oldFilethree, setOldFilethree] = useState("");
  const [oldFilefour, setOldFilefour] = useState("");
  const [showList, setShowList] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showListView, setShowListView] = useState(false);
  const [department, setDepartment] = useState([]);
  const [eventTitle, setEventtitle] = useState([]);
  const [imageError, setImageError] = useState(false);
  const [eventFor, setEventFor] = useState("");
  // const [selectedFile, setSelectedFile] = useState(
  //     siteUrl + "files_list/" + showEdit.gallery_images
  //   );
  const [fromDate, setFromDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [editorContent, setEditorContent] = useState("");

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  useEffect(() => {
    if (showEdit && showEdit.gallery_images) {
      setSelectedFile(siteUrl + "files_list/" + showEdit.gallery_images);
    }
  }, [showEdit.gallery_images, siteUrl]);

  useEffect(() => {
    if (showEdit && showEdit.gallery_img2) {
      setSelectedFiletwo(siteUrl + "files_list/" + showEdit.gallery_img2);
    }
  }, [showEdit.gallery_img2, siteUrl]);

  useEffect(() => {
    if (showEdit && showEdit.gallery_img3) {
      setSelectedFilethree(siteUrl + "files_list/" + showEdit.gallery_img3);
    }
  }, [showEdit.gallery_img3, siteUrl]);

  useEffect(() => {
    if (showEdit && showEdit.gallery_img4) {
      setSelectedFilefour(siteUrl + "files_list/" + showEdit.gallery_img4);
    }
  }, [showEdit.gallery_img4, siteUrl]);

  useEffect(() => {
    if (!loader) getReport();
    liststDepartments();
    listClub();
  }, [JSON.stringify(tableParams.pagination)]);

  const getRandomuserParams = (params) => ({
    limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    name: params.pagination?.name,
    from_date: params.pagination?.from_date,
    to_date: params.pagination?.to_date,
  });
  const handleEventForChange = (e) => {
    setEventFor(e.target.value);
  };

  const liststDepartments = () => {
    axios.post(ServiceUrl.EVENTS.DEPARTMENT_LIST).then((res) => {
      if (res["data"].status == "1") {
        setDepartment(res["data"].data);
      } else {
        Toast.show({ content: res.data.message || "Error" });
      }
      setLoader(false);
    });
  };
  const listClub = () => {
    axios.post(ServiceUrl.EVENTS.CLUB_LIST).then((res) => {
      if (res["data"].status == "1") {
        setClub(res["data"].data);
      } else {
        toast.error(res["data"].message || "Error");
      }
      setLoader(false);
    });
  };

  const fileReaderChange = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFile(file.base64);
    setImageError(false);
  };
  const fileReaderChangetwo = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFiletwo(file.base64);
  };
  const fileReaderChangethree = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFilethree(file.base64);
  };

  const fileReaderChangefour = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFilefour(file.base64);
  };

  const clearFile = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFile("");
  };
  const clearFiletwo = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFiletwo("");
  };
  const clearFilethree = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFilethree("");
  };
  const clearFilefour = () => {
    if (!window.confirm("Do you want to remove?")) return;
    setSelectedFilefour("");
  };

  const getImagetwo = () => {
    if (selectedFiletwo && selectedFiletwo.length > 0) return selectedFiletwo;
    else if (oldFiletwo && oldFiletwo.length > 0)
      return getFileLiveUrl(oldFiletwo);
    return SELECT_USER_PHOTO;
  };

  const getImage = () => {
    if (selectedFile && selectedFile.length > 0) return selectedFile;
    else if (oldFile && oldFile.length > 0) return getFileLiveUrl(oldFile);
    return SELECT_USER_PHOTO;
  };
  const getImagethree = () => {
    if (selectedFilethree && selectedFilethree.length > 0)
      return selectedFilethree;
    else if (oldFilethree && oldFilethree.length > 0)
      return getFileLiveUrl(oldFilethree);
    return SELECT_USER_PHOTO;
  };

  const getImagefour = () => {
    if (selectedFiletfour && selectedFiletfour.length > 0)
      return selectedFiletfour;
    else if (oldFilefour && oldFilefour.lenght > 0)
      return getFileLiveUrl(oldFilefour);
    return SELECT_USER_PHOTO;
  };
  useEffect(() => {
    if (props.profilePhoto) setOldFile(props.profilePhoto);
  }, [props.profilePhoto]);

  const getReport = () => {
    setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();

    axios
      .post(
        ServiceUrl.EVENTS.LIST +
          "?" +
          jsonToQuery(getRandomuserParams(tableParams)) +
          "&emp_id=" +
          context.user.id
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setDataView(res["data"].data);
          console.log("k", res["data"].data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res["data"].count,
            },
          });
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  const handleEdit = (item) => {
    setEditView(item);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    if (!selectedFile) {
      setImageError(true);
      return;
    }
    if (!window.confirm("Do you want to save?")) {
      return;
    }
    setLoader(true);
    axios
      .post(ServiceUrl.EVENTS.SAVE_REPORTS, $("#frm_addLeave").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          document.getElementById("frm_addLeave").reset();
          if (props.onSuccess) props.onSuccess();

          Toast.show({ content: res["data"].message || "Saved" });
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
        setLoader(false);
      });
  };

  const handleFormSubmitForUpdate = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    if (!selectedFile) {
      setImageError(true);
      return;
    }
    if (!window.confirm("Do you want to save?")) {
      return;
    }
    setLoader(true);
    axios
      .post(ServiceUrl.EVENTS.UPDATE_REPORTS, $("#frm_update").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          document.getElementById("frm_update").reset();
          if (props.onSuccess) props.onSuccess();

          Toast.show({ content: res["data"].message || "Saved" });
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
        setLoader(false);
      });
  };
  return (
    <>
      <Header title="Event" backAction={true} rightActions={[]} />
      {showList && (
        <div className="">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                Event{" "}
                <FloatButton
                  icon={<PlusCircleOutlined style={{ verticalAlign: "3px" }} />}
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowList(false);

                    setShowForm(true);
                  }}
                />
              </Card.Header>
              <Card.Body className="fs-6">
                <br />
                <List>
                  <Row>
                    {dataView.map((item) => (
                      <List.Item
                        key={item.company_name}
                        prefix={
                          <Avatar
                            style={{
                              backgroundColor: "#f56a00",
                              verticalAlign: "middle",
                              textTransform: "uppercase",
                            }}
                            size="large"
                          >
                            Events
                          </Avatar>
                        }
                      >
                        {item.event_category} <br />
                        {item.department} :{" "}
                        {momentDate(item.created_on, "DD-MM-YYYY")}
                        <Button
                          size="sm"
                          variant="transparent"
                          title="Edit Event"
                          onClick={(e) => {
                            handleEdit(item);

                            setShowList(false);
                            setShowForm(false);
                            setShowListView(true);
                          }}
                        >
                          <i className="fa-solid fa-pen fs-6"></i>
                        </Button>
                      </List.Item>
                    ))}
                  </Row>
                </List>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
      {showForm && (
        <div className="">
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                ADD EVENT{" "}
                <FloatButton
                  icon={
                    <CloseCircleOutlined style={{ verticalAlign: "3px" }} />
                  }
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowForm(false);
                    setShowList(true);
                  }}
                />
              </Card.Header>
              <Card.Body>
                <Form
                  method="post"
                  noValidate
                  id="frm_addLeave"
                  onSubmit={handleFormSubmit}
                >
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        Event <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="select"
                        className="fw-bold form-select form-select-sm"
                        size="sm"
                        name="event_for"
                        value={eventFor}
                        onChange={handleEventForChange}
                      >
                        <option value="">-Select-</option>
                        <option value="College">College</option>
                        <option value="Department">Department</option>
                        <option value="Common">Common</option>
                        <option value="Club">Club</option>
                      </Form.Control>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Event Date <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="date"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="event_date"
                        onChange={(e) => {
                          setFromDate(e.target.value);
                        }}
                        value={fromDate}
                        required
                      />
                    </Col>
                  </Row>
                  {eventFor === "Department" && (
                    <Row>
                      <Col md={4}>
                        <label className="fs-sm">Department</label>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="department"
                        >
                          <option value="">-Select-</option>
                          {department.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.department}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                  )}

                  {eventFor === "Club" && (
                    <Row>
                      <Col md={4}>
                        <label className="fs-sm">Club</label>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="club"
                        >
                          <option value="">-Select-</option>
                          {club.map((item) => (
                            <option
                              key={item.srv_org_id}
                              value={item.srv_org_id}
                            >
                              {item.srv_org_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Collaboration With{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="collaboration_with"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Event / Program Name
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="event_category"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Participants Total{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="number"
                        name="total_participants"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm"> Male Participants</label>
                      <span className="text-danger">*</span>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="number"
                        name="male_participants"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm"> Female Participants</label>{" "}
                      <span className="text-danger">*</span>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="number"
                        name="female_participants"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm"> Beneficiaries </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="beneficiaries"
                        size="md"
                        rows="3"
                        cols={5}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Chief Guests with Designation{" "}
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="cheif_guest"
                        size="md"
                        rows="3"
                        cols={5}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">
                        {" "}
                        Guest of Honor with Designation
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="guest_of_honour"
                        size="md"
                        rows="3"
                        cols={5}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Event Photo 1</label>
                      <span className="text-danger"> (group image)*</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto"
                          value={selectedFile}
                        />
                        {selectedFile && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFile()}
                          >
                            x
                          </a>
                        )}
                        {selectedFile && (
                          <img
                            src={getImage()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChange}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFile ? "Change Image" : "Select Image"}
                          </Button>
                        </ReactFileReader>
                        {imageError && (
                          <div className="text-danger mt-2">
                            Please select an image.
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Event Photo 2</label>
                      <span className="text-danger"> (live image)</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto2"
                          value={selectedFiletwo}
                        />
                        {selectedFiletwo && selectedFiletwo.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFiletwo()}
                          >
                            x
                          </a>
                        )}
                        {selectedFiletwo && selectedFiletwo.length > 0 && (
                          <img
                            src={getImagetwo()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChangetwo}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFiletwo && selectedFiletwo.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Event Photo 3</label>
                      <span className="text-danger"> (live image)</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto3"
                          value={selectedFilethree}
                        />
                        {selectedFilethree && selectedFilethree.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFilethree()}
                          >
                            x
                          </a>
                        )}
                        {selectedFilethree && selectedFilethree.length > 0 && (
                          <img
                            src={getImagethree()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChangethree}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFilethree && selectedFilethree.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Attendance sheet</label>
                      <span className="text-danger"> (photo)</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto4"
                          value={selectedFiletfour}
                        />
                        {selectedFiletfour && selectedFiletfour.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFilefour()}
                          >
                            x
                          </a>
                        )}
                        {selectedFiletfour && selectedFiletfour.length > 0 && (
                          <img
                            src={getImagefour()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChangefour}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFiletfour && selectedFiletfour.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={4}>
                      <label className="fs-sm"> Description / Report</label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="content_html"
                        size="md"
                        rows="5"
                        cols={5}
                      />
                    </Col>
                  </Row>
                  {/* <Row className="mt-2">
              <Col md={12}>
                <ContentEditor
                  content={editorContent}
                  onEditorChange={(html) => setEditorContent(html)}
                />
                <input
                  type="hidden"
                  name="content_html"
                  value={editorContent}
                />
              </Col>
            </Row> */}

                  <Row className="mt-2">
                    <Col md={2}></Col>
                    <Col md={10}>
                      <div className="text-end">
                        <Button
                          type="reset"
                          size="sm"
                          variant="danger"
                          className="me-2"
                        >
                          <i className="fa fa-xmark me-2 pe-2 border-right"></i>
                          Reset
                        </Button>
                        <Button type="submit" size="sm" variant="secondary">
                          <i className="fa fa-check me-2 pe-2 border-right"></i>
                          Save
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}

      {showListView && (
        <div>
          <div className="container">
            <Card className="mb-2">
              <Card.Header style={{ position: "relative" }}>
                <h6> Edit Events </h6>
                <FloatButton
                  icon={<img src={MOB_ICONS.CLOSE_BUTTON} />}
                  type="default"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    top: "50%",
                    right: 24,
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={() => {
                    setShowForm(false);
                    setShowList(true);
                  }}
                />
              </Card.Header>
              <Card.Body>
                <Form
                  method="post"
                  noValidate
                  id="frm_update"
                  onSubmit={handleFormSubmitForUpdate}
                >
                  <input type="hidden" name="id" value={showEdit.id} />
                  {selectedFile && selectedFile != showEdit.gallery_images && (
                    <input
                      type="hidden"
                      name="eventphoto"
                      value={selectedFile}
                    />
                  )}
                  {selectedFiletwo &&
                    selectedFiletwo != showEdit.gallery_img2 && (
                      <input
                        type="hidden"
                        name="eventphoto2"
                        value={selectedFiletwo}
                      />
                    )}
                  {selectedFilethree &&
                    selectedFilethree != showEdit.gallery_img3 && (
                      <input
                        type="hidden"
                        name="eventphoto3"
                        value={selectedFilethree}
                      />
                    )}

                  {selectedFiletfour &&
                    selectedFiletfour != showEdit.gallery_img4 && (
                      <input
                        type="hidden"
                        name="eventphoto4"
                        value={selectedFiletfour}
                      />
                    )}

                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        Event <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="select"
                        className="fw-bold form-select form-select-sm"
                        size="sm"
                        name="event_for"
                        defaultValue={showEdit.event_for}
                        onChange={handleEventForChange}
                      >
                        <option value="">-Select-</option>
                        <option value="College">College</option>
                        <option value="Department">Department</option>
                        <option value="Common">Common</option>
                        <option value="Club">Club</option>
                      </Form.Control>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Event Date <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="date"
                        className="fw-bold text-uppercase mt-2"
                        size="sm"
                        name="event_date"
                        onChange={(e) => {
                          setFromDate(e.target.value);
                        }}
                        defaultValue={showEdit.event_date}
                        required
                      />
                    </Col>
                  </Row>

                  {eventFor === "Department" && (
                    <Row className="mt-2">
                      <Col md={2}>
                        <label className="fs-sm">Department</label>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="department"
                          defaultValue={showEdit.department}
                        >
                          <option value="">-Select-</option>
                          {department.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.department}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                  )}

                  {eventFor === "Club" && (
                    <Row className="mt-2">
                      <Col md={2}>
                        <label className="fs-sm">Club</label>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="club"
                          defaultValue={showEdit.club}
                        >
                          <option value="">-Select-</option>
                          {club.map((item) => (
                            <option
                              key={item.srv_org_id}
                              value={item.srv_org_id}
                            >
                              {item.srv_org_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                  )}

                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        Event Program Name<span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="event_category"
                        className="fw-bold mt-2"
                        size="sm"
                        defaultValue={showEdit.event_category}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Collaboration With{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="text"
                        name="collaboration_with"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                        defaultValue={showEdit.collaboration_with}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Participants Total{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="number"
                        name="total_participants"
                        className="fw-bold mt-2"
                        size="sm"
                        required
                        defaultValue={showEdit.total_participants}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Male Participants<span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="number"
                        name="male_participants"
                        className="fw-bold mt-2"
                        size="sm"
                        defaultValue={showEdit.male_participants}
                        required
                        // required
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Female Participants
                        <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        type="number"
                        name="female_participants"
                        className="fw-bold mt-2"
                        size="sm"
                        defaultValue={showEdit.female_participants}
                        required
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm"> Beneficiaries </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="beneficiaries"
                        size="md"
                        rows="3"
                        cols={5}
                        defaultValue={showEdit.beneficiaries}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Chief Guests with Designation{" "}
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="cheif_guest"
                        size="md"
                        defaultValue={showEdit.cheif_guest}
                        rows="3"
                        cols={5}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2}>
                      <label className="fs-sm">
                        {" "}
                        Guest of Honor with Designation{" "}
                      </label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="guest_of_honour"
                        size="md"
                        defaultValue={showEdit.guest_of_honour}
                        rows="3"
                        cols={5}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <label className="fs-sm">Event Photo 1</label>
                      <span className="text-danger"> (group image)*</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto"
                          value={selectedFile}
                        />
                        {selectedFile && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFile()}
                          >
                            x
                          </a>
                        )}
                        {selectedFile && (
                          <img
                            src={getImage()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChange}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFile ? "Change Image" : "Select Image"}
                          </Button>
                        </ReactFileReader>
                        {imageError && (
                          <div className="text-danger mt-2">
                            Please select an image.
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col md={4}>
                      <label className="fs-sm">Event Photo 2</label>
                      <span className="text-danger"> (live image)</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto2"
                          value={selectedFiletwo}
                        />
                        {selectedFiletwo && selectedFiletwo.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFiletwo()}
                          >
                            x
                          </a>
                        )}
                        {selectedFiletwo && selectedFiletwo.length > 0 && (
                          <img
                            src={getImagetwo()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChangetwo}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFiletwo && selectedFiletwo.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={4}>
                      <label className="fs-sm">Event Photo 3</label>
                      <span className="text-danger"> (live image)</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto3"
                          value={selectedFilethree}
                        />

                        {selectedFilethree && selectedFilethree.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFilethree()}
                          >
                            x
                          </a>
                        )}
                        {selectedFilethree && selectedFilethree.length > 0 && (
                          <img
                            src={getImagethree()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChangethree}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFilethree && selectedFilethree.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={4}>
                      <label className="fs-sm">Attendance sheet</label>
                      <span className="text-danger"> (photo)</span>
                    </Col>
                    <Col md={4}>
                      <div
                        className="mt-2"
                        style={{
                          width: "180px",
                          marginLeft: "atuo",
                          marginRight: "auto",
                        }}
                      >
                        <input
                          type="hidden"
                          name="eventphoto4"
                          value={selectedFiletfour}
                        />
                        {selectedFiletfour && selectedFiletfour.length > 0 && (
                          <a
                            className="img-close-btn"
                            onClick={(e) => clearFilefour()}
                          >
                            x
                          </a>
                        )}
                        {selectedFiletfour && selectedFiletfour.length > 0 && (
                          <img
                            src={getImagefour()}
                            style={{
                              width: "180px",
                              cursor: "pointer",
                              height: "190px",
                            }}
                          />
                        )}
                        <ReactFileReader
                          base64={true}
                          handleFiles={fileReaderChangefour}
                          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                        >
                          <Button size="sm" type="button" className="btn-block">
                            <i className="fa-solid fa-file-image me-2"></i>
                            {selectedFiletfour && selectedFiletfour.length > 0
                              ? "Change Image"
                              : "Select Image"}
                          </Button>
                        </ReactFileReader>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={4}>
                      <label className="fs-sm"> Description / Report</label>
                    </Col>
                    <Col md={4}>
                      <Form.Control
                        as="textarea"
                        name="content_html"
                        size="lg"
                        rows="5"
                        defaultValue={showEdit.content}
                        cols={5}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={2}></Col>
                    <Col md={10}>
                      <div className="text-end">
                        <Button type="submit" size="sm" variant="primary">
                          <i className="fa fa-check me-2 pe-2 border-right"></i>
                          Update
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};
export default Events;
